import {
    ActionService,
    component,
    ConfigurationService,
    dateField,
    EntityData,
    field,
    JwtHttpClientService,
    ResourceModule
} from "@fedelta-pos/data-client";
import {inject, Injectable} from "@angular/core";
import {AddressData} from '../customer-info/address.data';

export class IntegratedDeliveryAddressValidationRequestData extends EntityData<IntegratedDeliveryAddressValidationRequestData> {
    @field storeId: number;
    @dateField expectedCompletion: Date;
    @component address: AddressData;
}

@Injectable({providedIn: "root"})
export class IntegratedDeliveryAddressValidationService extends ActionService {
    constructor() {
        const http: JwtHttpClientService = inject(JwtHttpClientService);
        const configService: ConfigurationService = inject(ConfigurationService);
        const nameSpace: string = inject<string>(ResourceModule.RESOURCE_NAMESPACE_KEY);
        const actionNames: string[] = inject<string[]>(ResourceModule.ACTION_NAMES_KEY);
        const useAsync: boolean = inject<boolean>(ResourceModule.RESOURCE_USE_ASYNC);

        console.log("--- IntegratedDeliveryAddressValidationService");

        super(http, nameSpace, "integrated-delivery-address-validation", configService, useAsync, actionNames);
    }
}
